module.exports = __webpack_public_path__ + "static/media/cannon.770692b2.webp";